<template>
    <div
        class="input-drop__wrapper"
        :class="[{ opened }, `wrapper--${type}`]"
        @click="opened = !opened"
        ref="dropdown"
    >
        <div class="input-drop__value">
            <span v-html="currentLabel"></span>
            <svg class="caret" :class="[`icon--${icon}`]">
                <use :xlink:href="`${icons[icon]}#icon`"></use>
            </svg>

            <div class="input-drop__dropdown" :class="[type]">
                <div
                    v-for="(optiongroup, optiongroupkey) in options"
                    :key="`optiongroup-${optiongroupkey}`"
                    class="input-drop__group"
                >
                    <div
                        v-for="(option, optionkey) in optiongroup"
                        :key="optionkey"
                        @click="updateInput(option.value)"
                        class="input-drop__option"
                        :class="[
                            {
                                selected:
                                    option.value === value ||
                                    (option.comparable &&
                                        option.comparable === comparable),
                            },
                        ]"
                    >
                        <span class="input-drop__option__label">
                            {{ option.label }}
                        </span>
                        <span
                            class="input-drop__option__long"
                            v-html="option.long"
                        >
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: [Number, String, Date],
        options: {
            type: [Object, Array],
            default() {
                return {};
            },
        },
        comparable: [Number, String],
        type: {
            type: String,
            default: 'down',
        },
        icon: {
            type: String,
            default: 'arrow-drop-down',
        },
        label: {
            type: String,
            default: null,
        },
    },
    computed: {
        currentLabel() {
            let found = null;

            this.options.forEach((optiongroup) => {
                if (!found) {
                    found = optiongroup.find(
                        (item) =>
                            // eslint-disable-next-line operator-linebreak
                            item.value === this.value ||
                            // eslint-disable-next-line operator-linebreak
                            (item.comparable &&
                                item.comparable === this.comparable),
                    );
                }
            });

            if (!found) {
                return null;
            }

            if (this.label) {
                return `${this.label} <span class="input-drop__value--current">${found.label}</span>`;
            }

            return found.label;
        },
    },
    data() {
        return {
            icons: window.here.icons,
            opened: false,
        };
    },

    mounted() {
        document.addEventListener('click', this.onClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.onClickOutside);
    },
    methods: {
        updateInput(value) {
            this.$emit('input', value);
        },
        onClickOutside(event) {
            const { dropdown } = this.$refs;
            if (!dropdown || dropdown.contains(event.target)) return;
            this.opened = false;
        },
    },
};
</script>

<style lang="scss">
.input-drop__wrapper {
    border: 1px solid #bcb4b0;
    border-radius: 4px;
    height: 40px;
    padding-left: 12px;
    padding-right: 12px;
    transition: border-color 0.3s ease-in;
    cursor: pointer;
    position: relative;

    .input-drop__value {
        user-select: none;
        border: 0;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0;
        font-weight: 500;
        color: #4e3a30;
        &:focus {
            outline: 0;
        }
    }

    &:focus-within,
    &:hover {
        border-color: #c8532b;
    }

    .caret {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 6px;
        right: 6px;
        color: #c8532b;
    }

    &.opened {
        .input-drop__dropdown {
            display: block;
            .input-drop__option {
                &.selected {
                    color: #c8532b;
                }
            }
        }
    }

    &.wrapper--seamless,
    &.wrapper--seamless-combined {
        font-size: 18px;
        border: 0;
        display: inline-block;
        padding-right: 40px;

        svg {
            color: rgba(78, 58, 48, 0.38);
        }

        &:hover {
            svg {
                color: #4e3a30;
            }
        }

        .input-drop__dropdown {
            padding: 35px 8px 20px 8px;
            width: 239px;
        }
    }

    &.wrapper--seamless-combined {
        width: 100%;
    }
}

.input-drop__dropdown {
    background: #fff;
    box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.15);
    transform: translateY(12px);
    border-radius: 0px 4px 4px 4px;
    position: absolute;
    top: 100%;
    right: 0;
    display: none;
    z-index: 1;
    user-select: none;

    &.down {
        max-height: 347px;
        min-width: 178px;
        overflow-y: auto;

        .input-drop__option__long {
            display: none;
        }
    }

    &.right {
        width: 714px;
        .input-drop__option__label {
            display: none;
        }
    }

    &.seamless-combined {
        top: 0;
        left: 100%;
        .input-drop__group {
            display: none !important;
        }
    }

    .input-drop__group {
        position: relative;
        &:after {
            content: '';
            display: block;
            position: absolute;
            left: 12px;
            right: 12px;
            bottom: 0;
            background-color: #ffb100;
            height: 1px;
        }

        &:last-child {
            &:after {
                display: none;
            }
        }
    }

    .input-drop__option {
        font-size: 16px;
        padding-left: 12px;
        padding-right: 12px;
        background-color: #fff;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: #f2f2f2;
        }

        &.selected {
            font-weight: 500;
        }
    }

    &.right {
        padding: 20px;
        .input-drop__group {
            display: flex;
            gap: 12px;
            .input-drop__option {
                flex: 1 0 12.5%;
                border: 1px solid #dcd8d6;
                border-radius: 3px;
                font-weight: 400;
                text-align: center;
                line-height: 1em;
                padding-top: 12px;
                padding-bottom: 12px;
                cursor: pointer;
                .upper {
                    font-weight: 600;
                    font-size: 16px;
                    display: block;
                    padding-bottom: 12px;
                    color: #4e3a30;
                }
                .bottom {
                    font-weight: 400;
                    font-size: 14px;
                }
                &.selected {
                    background-color: #c8532b;
                    color: #fff;
                    border-color: #c8532b;
                    .upper {
                        color: #fff;
                    }
                }
            }
        }
    }
}

.wrapper--seamless {
    .icon--chevron-right-small {
        transform: rotate(90deg);
    }
}

.input-drop__value--current {
    color: rgba(78, 58, 48, 0.6);
    font-size: 14px;
}
</style>
